import React, {Component} from 'react'
import NewsList from './NewsList'

const Jeyu = {
  ContentBox: {
    padding: 0,
  },
  Box: {
    background: '#333',
    minHeight: '100vh'
  }
}

export default class NEWS extends Component {
  componentDidMount () {
   window.scrollTo(0, 0)
  }
  componentWillUnmount() {
   window.scrollTo(0, 0)
  }
  render() {
    return(
      <div className="container-fluid" style={Jeyu.Box}>
       <div className="row">
        <div className="container">
         <div className="row">
          <div style={Jeyu.ContentBox}>
           <NewsList />
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/News.js